import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface LandingCtaProps {
  onSignIn: () => void
  onLearnMore?: (() => void) | undefined
}

export function PhilosophySection(): ReactElement {
  const { t } = useTranslation('common')

  return (
    <section className="lp-philosophy">
      <div className="lp-philosophy-quote">
        <p>
          {t('landing.philosophy.quoteLine1')}
          <br />
          {t('landing.philosophy.quoteLine2')}
          <br />
          {t('landing.philosophy.quoteLine3')}
        </p>
      </div>
      <div className="lp-philosophy-body">
        <p>{t('landing.philosophy.body')}</p>
      </div>
    </section>
  )
}

export function StatementSection(): ReactElement {
  const { t } = useTranslation('common')

  return (
    <section className="lp-statement">
      <p className="lp-statement-text">
        <span className="lp-statement-accent">{t('landing.statement.evidence')}</span>
        <span className="lp-statement-dot">&middot;</span>
        {t('landing.statement.clarity')}
        <span className="lp-statement-dot">&middot;</span>
        <span className="lp-statement-accent">{t('landing.statement.sovereignty')}</span>
      </p>
    </section>
  )
}

export function CtaSection({ onSignIn, onLearnMore }: LandingCtaProps): ReactElement {
  const { t } = useTranslation('common')

  return (
    <section className="lp-cta">
      <button type="button" className="lp-btn lp-btn-primary" onClick={onSignIn}>
        {t('landing.cta.getStarted')} &rarr;
      </button>
      <button type="button" className="lp-btn lp-btn-ghost" onClick={onLearnMore}>
        {t('landing.cta.learnMore')}
      </button>
    </section>
  )
}

export function FooterSection(): ReactElement {
  const { t } = useTranslation('common')

  return (
    <footer className="lp-footer">
      <span className="lp-footer-left">{t('landing.footer.status')}</span>
      <span className="lp-footer-contact">
        <a href={`mailto:${t('landing.footer.contact')}`}>{t('landing.footer.contact')}</a>
        {' \u00B7 '}
        {t('landing.footer.copyright')}
      </span>
    </footer>
  )
}
